import React from 'react'
import CurrencyInputField from '../../formFields/currencyInputField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <CurrencyInputField {...fieldProps} />
))
